var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivePlayground({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6932_1953",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6932_1953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 22.0002C3.71667 22.0002 3.47917 21.9044 3.2875 21.7127C3.09583 21.521 3 21.2835 3 21.0002V7.0502C3 6.8002 3.05 6.5877 3.15 6.4127C3.25 6.2377 3.41667 6.1002 3.65 6.0002L13.65 2.0002C13.9833 1.86687 14.2917 1.9127 14.575 2.1377C14.8583 2.3627 15 2.6502 15 3.0002V6.0002H16C16.2833 6.0002 16.5208 6.09603 16.7125 6.2877C16.9042 6.47937 17 6.71687 17 7.0002V10.0002H15V8.0002H5V20.0002H10.175L12.175 22.0002H4ZM9 6.0002H13V4.4502L9 6.0002ZM17 22.0002C15.6167 22.0002 14.4375 21.5127 13.4625 20.5377C12.4875 19.5627 12 18.3835 12 17.0002C12 15.6169 12.4875 14.4377 13.4625 13.4627C14.4375 12.4877 15.6167 12.0002 17 12.0002C18.3833 12.0002 19.5625 12.4877 20.5375 13.4627C21.5125 14.4377 22 15.6169 22 17.0002C22 18.3835 21.5125 19.5627 20.5375 20.5377C19.5625 21.5127 18.3833 22.0002 17 22.0002ZM15.75 19.5002L19.75 17.0002L15.75 14.5002V19.5002Z",
    fill: "#FDA409"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePlayground);
export default __webpack_public_path__ + "static/media/active_playground.dcb7e3e81a393a10510adc532a260cc2.svg";
export { ForwardRef as ReactComponent };